import { initConsoleLogger } from './consoleLogger';
import { initFetchLogger } from './networkLogger';

export * from './consoleLogger';
export * from './networkLogger';
export * from './deviceInfo';

let isTelemetryInitialized = false;

export const initTelemetry = (): void => {
  if (isTelemetryInitialized) return;
  isTelemetryInitialized = true;
  initConsoleLogger();
  initFetchLogger();
};
